import React, { useState } from "react";
import { Button, SectionTitle } from "@components";
import IconCopyShare from "@assets/icon_copy_plus.svg";
import { useAppDispatch, useAppSelector } from "@hooks";
import { setCV } from "@store";
import { HeadingIds } from "@constants";
import { createEducationNewPoint } from "@utils";
import { EducationNewList } from "./EducationNewList";
import { CopyModal } from "./components";
import { fields } from "./localization";
import commonStyles from "../../CV.common.scss";
export function EducationNew() {
    var _a;
    const [isModalOpen, setIsModalOpen] = useState(false);
    const dispatch = useAppDispatch();
    const { cv } = useAppSelector((state) => state.cv);
    const { language, isViewOnly } = useAppSelector((state) => state.ui);
    const field = fields(language);
    const educationNew = ((_a = cv === null || cv === void 0 ? void 0 : cv.educationNewDisplay) === null || _a === void 0 ? void 0 : _a.length)
        ? cv.educationNewDisplay
        : [createEducationNewPoint()];
    const setEducationNew = (educationNewDisplay) => {
        dispatch(setCV(Object.assign(Object.assign({}, cv), { educationNewDisplay })));
    };
    const handleAdd = () => {
        if (educationNew.length === 0) {
            setEducationNew([createEducationNewPoint(), createEducationNewPoint()]);
        }
        else {
            setEducationNew([...educationNew, createEducationNewPoint()]);
        }
    };
    const copyButton = !isViewOnly && (React.createElement(Button, { variant: "text", color: "secondary", onClick: () => setIsModalOpen(true), leftIcon: React.createElement(IconCopyShare, null) }, field.copyToRevision));
    return (React.createElement("section", { id: HeadingIds.EducationNew, className: commonStyles.section },
        React.createElement(CopyModal, { educationItems: educationNew, isOpen: isModalOpen, onClose: () => setIsModalOpen(false) }),
        React.createElement(SectionTitle, { title: field.title, handleAdd: handleAdd, addButtonLabel: field.addEducation, additionalComponent: copyButton }),
        React.createElement(EducationNewList, { items: educationNew, onEdit: setEducationNew })));
}
